import { render, staticRenderFns } from "./case-studies-clubs.vue?vue&type=template&id=3f7c96f7"
import script from "./case-studies-clubs.vue?vue&type=script&lang=ts"
export * from "./case-studies-clubs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports